import * as React from 'react';
import defaultAvatar from '@images/default.png';
import { BattleRankItem } from '@/fetch.ts';
const PkItem: React.FC<BattleRankItem> = props => (
  <div className='pkitem'>
    <div className='left'>
      <div
        className='avatarcover'
        onClick={(): void => {
          window.open('https://m.huya.com/' + props.tLeft.tJump.iRoomId, '_blank');
        }}
      >
        <img className='avatar'
          src={props.tLeft.sLogoUrl}
          onError={(event: any): void => {
            event.target.onerror = null;
            event.target.src = defaultAvatar;
          }}
          title={props.tLeft.sNickName}/>
        {
          props.tLeft.lScore > props.tRight.lScore &&
            <i className='crown'></i>
        }
        {
          props.tLeft.tJump.bLive &&
            <i className='living'></i>
        }
      </div>
      <div className='message'>
        <h4
          onClick={(): void => {
            window.open('https://m.huya.com/' + props.tLeft.tJump.iRoomId, '_blank');
          }}
        >{props.tLeft.sNickName}</h4>
        <div><span>热度&nbsp;</span><h5>{props.tLeft.lScore}</h5></div>
      </div>
    </div>
    <i></i>
    <div className='right'>
      <div
        className='avatarcover'
        onClick={(): void => {
          window.open('https://m.huya.com/' + props.tRight.tJump.iRoomId, '_blank');
        }}
      >
        <img className='avatar'
          src={props.tRight.sLogoUrl}
          onError={(event: any): void => {
            event.target.onerror = null;
            event.target.src = defaultAvatar;
          }}
          title={props.tRight.sNickName}/>
        {
          props.tRight.lScore > props.tLeft.lScore &&
            <i className='crown'></i>
        }
        {
          props.tRight.tJump.bLive &&
            <i className='living'></i>
        }
      </div>
      <div className='message'>
        <h4
          onClick={(): void => {
            window.open('https://m.huya.com/' + props.tLeft.tJump.iRoomId, '_blank');
          }}
        >{props.tRight.sNickName}</h4>
        <div><span>热度&nbsp;</span><h5>{props.tRight.lScore}</h5></div>
      </div>
    </div>
  </div>
)

export default PkItem;